import { PrivilegesMap } from "../context/RoleContext";
import { createSessionStore } from "./session-storage/create-session-store";

type PermissionValue = PrivilegesMap | null;

type Action = [PermissionValue, (v: PermissionValue) => void];

/**
 * Privileges belong to the logged-in user, so they live in sessionStorage
 * beside the user and the tokens — a login in another tab must not hand this
 * tab a different role's permissions.
 */
const permissionStore = createSessionStore<PermissionValue>(
  "permissions",
  null
);

/**
 *
 * @returns [permissions, setPermissions]
 * @description This hook is used to store the permissions in the session storage
 * @example
 * const [permissions, setPermissions] = usePermissionStore();
 * setPermissions(permissions);
 *
 * @author [Rajkumar Rathod]
 */
const usePermissionStore = (): Action => {
  const [permissions, setPermissions] = permissionStore.useStore();

  return [permissions ?? null, setPermissions];
};

export default usePermissionStore;
